import React from "react";
import MineAds from "../components/business/MineAds";

function MineAdsPage(props) {
  return <MineAds props={props} />;
}

export default MineAdsPage;
